module.exports = __webpack_public_path__ + "img/background_white-icon.b980e3e.svg";